import { render, staticRenderFns } from "./FacilityImport.vue?vue&type=template&id=4800dd7e&scoped=true&"
import script from "./FacilityImport.vue?vue&type=script&lang=js&"
export * from "./FacilityImport.vue?vue&type=script&lang=js&"
import style0 from "./FacilityImport.vue?vue&type=style&index=0&id=4800dd7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4800dd7e",
  null
  
)

export default component.exports